var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoRoundLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    fill: "#F1F252"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2543 17.4778C47.3352 17.4778 50.1945 18.3167 50.1945 18.3167L58.6349 35.7547L58.564 35.8306L47.6895 29.2802C41.3957 25.474 36.8149 23.4929 33.097 23.6446C29.1623 23.7205 26.8032 26.9198 26.8032 31.5649C26.9449 43.4431 38.107 58.0655 49.1941 58.0655C53.7207 58.0655 56.0756 56.5902 57.4553 54.8072L41.0372 36.5893V36.5134H63.5699C63.9283 38.1868 64.07 40.5515 64.07 41.462C64.07 54.7903 53.9833 65.5263 41.5374 65.5263C29.0915 65.5263 18.9297 54.7903 18.9297 41.462C18.9297 28.1337 29.0164 17.4736 42.2501 17.4736L42.2543 17.4778Z",
    fill: "#1C1B18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoRoundLogo);
export default __webpack_public_path__ + "static/media/goRoundLogo.d4e633487d5a9a5d18aa462e52fc575e.svg";
export { ForwardRef as ReactComponent };